import template from "./index.html";
import "./index.less";

function controller($element, $transclude) {
	this.$postLink = () => {
		const content = angular.element(
			$element[0].querySelector(".loading-content")
		);
		content.append($transclude());
	};
}

export default angular
	.module("vesl.components.loading-tracker", [])
	.component("loadingTracker", {
		transclude: true,
		template,
		controller,
		bindings: {
			tracker: "<"
		}
	}).name;
